import React from 'react';
import twMerge from 'utilities/src/twMerge';
import FacebookRoundIcon from '../../icons/FacebookRoundIcon';
import XSquareIcon from '../../icons/XSquareIcon';
import LinkedinSquareIcon from '../../icons/LinkedinSquareIcon';
import WhatsappRoundIcon from '../../icons/WhatsappRoundIcon';
import EmailSquareIcon from '../../icons/EmailSquareIcon';

const socialMedia = (postTitle: string, postUrl: string) => [
  {
    name: 'Facebook',
    icon: <FacebookRoundIcon className="fill-site-neutrals-800 h-6 w-6" />,
    link: `https://www.facebook.com/sharer/sharer.php?caption=${postTitle}&u=${postUrl}`,
  },
  {
    name: 'LinkedIn',
    icon: <LinkedinSquareIcon className="fill-site-neutrals-800 h-6 w-6" />,
    link: `https://www.linkedin.com/shareArticle?mini=true&url=${postUrl}&title=${postTitle}`,
  },
  {
    name: 'X',
    icon: <XSquareIcon className="fill-site-neutrals-800 h-6 w-6" />,
    link: `https://x.com/intent/tweet?text=${postTitle}&url=${postUrl}`,
  },
  {
    name: 'Whatsapp',
    icon: <WhatsappRoundIcon className="fill-site-neutrals-800 h-6 w-6" />,
    link: `whatsapp://send?text=${postTitle} ${postUrl}`,
  },
  {
    name: 'Email',
    icon: <EmailSquareIcon className="fill-site-neutrals-800 h-6 w-6" />,
    link: `mailto:?subject=${postTitle}&body=${postTitle}%20${postUrl}`,
  },
];

type ShareComponentProps = {
  postTitle: string;
  postUrl: string;
  classNames?: string;
};

export default function ShareComponent({ postTitle, postUrl, classNames }: ShareComponentProps) {
  return (
    <div
      className={twMerge(
        'bg-site-neutrals-25 shadow-lv3 flex w-fit items-center justify-center gap-4 rounded-2xl p-3',
        classNames,
      )}
    >
      {socialMedia(postTitle, postUrl).map((social) => (
        <div key={social.name}>
          <a href={social.link} target="_blank" rel="noreferrer">
            {social.icon}
          </a>
        </div>
      ))}
    </div>
  );
}
